// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// ✅ Firebase config from your Firebase Console
const firebaseConfig = {
  apiKey: "AIzaSyBEye6vEYOkh8cuyb2nrosMFwU7EBLh8pW",
  authDomain: "lakderana-cabs.firebaseapp.com",
  projectId: "lakderana-cabs",
  storageBucket: "lakderana-cabs.appspot.com",
  messagingSenderId: "547527595391",
  appId: "1:547527595391:web:cdc543a4fbf75b6f57f64a",
};

// ✅ Initialize Firebase App
const app = initializeApp(firebaseConfig);

// ✅ Initialize Firestore
const db = getFirestore(app);

// ✅ Export both
export { app, db };
